import { AccountClient } from '@nile/graphql';
import { isEmpty } from 'lodash';

export interface ApiConfig {
  fetchFeatures: any;
  updateFeature: any;
}

export const fetchFeaturesFromAPI = async (
  apiConfig: ApiConfig,
  featureType: string,
  useSubFeatures: boolean
): Promise<{
  featureData: FeatureData | null;
  features: FeatureData[];
}> => {
  if (!apiConfig?.fetchFeatures) {
    return { featureData: null, features: [] };
  }

  try {
    const result = await AccountClient.query({
      query: apiConfig.fetchFeatures,
      variables: {
        input: {
          listInfo: {
            pageSize: 20,
            page: 1,
            condition: {
              joinOperator: 'AND',
              operands: [
                {
                  attribute: 'subFeatures',
                  operator: 'isEmpty',
                  value: null
                }
              ]
            }
          }
        }
      },
      fetchPolicy: 'no-cache'
    });

    const aiFeatures = result?.data?.getAIFeatureList?.feature;

    //filter aiFeatureGroup.constant by featureType
    if (isEmpty(aiFeatures)) {
      return { featureData: null, features: [] };
    }
    const itemToCheck = aiFeatures.filter(
      (item: any) =>
        item?.aiFeatureGroup?.constant === featureType ||
        item?.constant === featureType
    );

    if (!itemToCheck) {
      return { featureData: null, features: [] };
    }

    return {
      featureData: itemToCheck,
      features: itemToCheck
    };
  } catch (error) {
    console.error('Error fetching features from API:', error);
  }

  return { featureData: null, features: [] };
};

export const updateFeatureViaAPI = async (
  updateMutation: any,
  featureId: string,
  newState: string
) => {
  try {
    const result = await updateMutation({
      variables: {
        input: {
          featureId: featureId,
          state: newState
        }
      }
    });
    return result;
  } catch (error) {
    console.error('Error updating feature via API:', error);
    throw error;
  }
};
